import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { CDN_URL } from '../components/common/constants';

// Import all auth components
import LoginForm from '../components/auth/LoginForm';
import ForgotPassword from '../components/auth/ForgotPassword';
import ResetPassword from '../components/auth/ResetPassword';

const LoginPage = () => {
    const [backgroundImage, setBackgroundImage] = useState('');
    const location = useLocation();
    
    useEffect(() => {
        // Generate a random number between 1 and 17
        const randomImageNum = Math.floor(Math.random() * 17) + 1;
        
        // Format the number with leading zero if needed (01, 02, etc.)
        const formattedNum = randomImageNum.toString().padStart(2, '0');
        
        // Construct the image URL
        const imageUrl = `${CDN_URL}/parki/app_theme/assets/img/auth_images/img_${formattedNum}.jpg`;
        
        setBackgroundImage(imageUrl);
    }, []); // Empty dependency array ensures this runs once on component mount

    // Function to determine which component to render based on the current path
    const renderAuthComponent = () => {
        const path = location.pathname;
        
        if (path === '/forgot-password') {
            return <ForgotPassword />;
        } else if (path === '/reset-password') {
            return <ResetPassword />;
        } else {
            // Default to LoginForm for root, /login, or any unspecified path
            return <LoginForm />;
        }
    };

    // Set page title based on the current path
    useEffect(() => {
        const path = location.pathname;
        
        if (path === '/forgot-password') {
            document.title = 'Parki | Forgot Password';
        } else if (path === '/reset-password') {
            document.title = 'Parki | Reset Password';
        } else {
            document.title = 'Parki | Login';
        }
    }, [location.pathname]);

    return (
        <div className="authentication-wrapper authentication-cover">
            {/* Logo */}
            <Link to="/" className="app-brand auth-cover-brand">
                <span className="app-brand-logo">
                    <div></div>
                    <img
                        src={`${CDN_URL}/parki/logo/Logo+files/PNGs+-+SVGs/SVG/Asset+5.svg`}
                        alt="Logo"
                        className="w-px-130 h-auto"
                    />
                </span>
            </Link>

            <div className="authentication-inner row m-0">
                {/* Left Side Banner */}
                <div className="d-none d-xl-flex col-xl-8 p-0">
                    <div className="auth-bg-img">
                        <img
                            src={backgroundImage}
                            alt=""
                            className="auth-cover-image"
                        />
                    </div>
                </div>

                {/* Auth Component (Login, Forgot Password, or Reset Password) */}
                <div className="d-flex col-12 col-xl-4 align-items-center authentication-bg p-sm-12 p-6">
                    <div className="w-px-400 mx-auto mt-12 pt-5">
                        {renderAuthComponent()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;